import { configureStore } from "@reduxjs/toolkit";
import SetActiveTabSlice from "../reducers/slices/SetActiveTabSlice";
import SetFaqSlice from "../reducers/slices/SetFaqSlice";
import getSecDataSlice from "../reducers/slices/SetSecDataSlice";
import setAccordionStateDetailsSlice from "../reducers/slices/FaqAccordionSlice";
import setDefaultDataSlice from "../reducers/slices/SetDefaultDataSlice";
import setDefaultFaqSlice from "src/reducers/slices/SetDefaultFaqSlice";
import DefaultFaqAccordianSlice from "src/reducers/slices/DefaultFaqAccordianSlice";
import formReducer from "../reducers/slices/formSliceStepOne";
import buyersReducer from "../reducers/slices/buyersSlice";
import stepTrackerReducer from "src/reducers/slices/stepTrackerSlice.ts";
import profileSlice from "src/reducers/slices/ProfileSlice";
import authReducer from "src/reducers/slices/AuthSlice";
import companyInfoReducer from "src/reducers/slices/CompanyInfoSlice";
import bannerReducer from "src/reducers/slices/BannerSlice";
import feedbackReducer from "src/reducers/slices/FeedBackSlice";
import sendOtpPayloadReducer from "src/reducers/slices/SendOtpSlice";
import statusReducer from "src/reducers/slices/BuyerStatusSlice";
import achEnrollmentStepsSlice from "src/reducers/slices/AchEnrollmentStepsSlice";
import requestIdReducer from "../reducers/slices/RequestIdSlice";

const store = configureStore({
  reducer: {
    setActiveTab: SetActiveTabSlice,
    setFaq: SetFaqSlice,
    getSecData: getSecDataSlice,
    activeAccordion: setAccordionStateDetailsSlice,
    setDefaultFaq: setDefaultFaqSlice,
    activeDefaultAccordian: DefaultFaqAccordianSlice,
    getDefaultData: setDefaultDataSlice,
    forms: formReducer,
    buyersL: buyersReducer,
    stepTracker: stepTrackerReducer,
    profile: profileSlice,
    auth: authReducer,
    companyInfo: companyInfoReducer,
    banner: bannerReducer,
    feedback: feedbackReducer,
    sendOtpData: sendOtpPayloadReducer,
    buyerStatus: statusReducer,
    achEnrollmentStep: achEnrollmentStepsSlice,
    requestId: requestIdReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
